"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(require("./getDisplayName"));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/~/recompose/wrapDisplayName.js
// module id = 132
// module chunks = 0